import MessagePositionDescriptor from 'conversations-message-history/common-message-format/records/MessagePositionDescriptor';
import { LAST_OUTGOING_CHANNEL_MESSAGE_ID } from 'conversations-message-history/common-message-format/constants/messagePositionDescriptorKeyPaths';
import { fromJS } from 'immutable';
export const buildMessagePositionDescriptor = messageId => {
  return new MessagePositionDescriptor({
    descriptors: fromJS({
      [LAST_OUTGOING_CHANNEL_MESSAGE_ID]: messageId
    })
  });
};